import {importExportMenuData} from "./importExport"
import {
    questionsMenuData,
    usedId,
    checkedUsedId,
    unusedId,
    checkedUnusedId,
    readyForUseId,
    checkedReadyForUseId
} from "./questionsMenu"
import {findVal} from "./common"
import {QUESTION_STATUSES} from "../modules/questions"


export const getStatus = massAction => {
    return (massAction === usedId || massAction === checkedUsedId) ?
        QUESTION_STATUSES[3].status :
        (massAction === unusedId || massAction === checkedUnusedId) ?
            QUESTION_STATUSES[2].status :
            (massAction === readyForUseId || massAction === checkedReadyForUseId) ?
                QUESTION_STATUSES[1].status :
                null
}

export const checkMenuDataItem = (menuData) => (menuId, submenuId) => {
    if (!Object.keys(menuData).includes(menuId)) return false

    let submenus = []
    Object.values(menuData).forEach(menuDataItem => {
        submenus = [
            ...submenus,
            ..._findSubmenus(menuDataItem)
        ]
    })

    if (!submenus.includes(submenuId)) return false
    return true
}

const _findSubmenus = ({id, submenus}) => {
    if (typeof submenus === 'undefined') return id
    let result = []
    Object.values(submenus).forEach(submenuItem => {
        let _res = _findSubmenus(submenuItem)
        result = [
            ...result,
            ...(Array.isArray(_res) ? _res : [_res])
        ]
    })
    return result
}

export const getMenuData = () => ({
    ...questionsMenuData,
    ...importExportMenuData,
})

export const getSubmenuTextById = submenuId => {
    let menuData = getMenuData()
    let subMenuItem = findVal(menuData, submenuId) || {}
    let {text} = subMenuItem
    return text
}


window.___getSubmenuTextById = getSubmenuTextById
window.___getMenuData = getMenuData


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/helpers/menu.js